import { Injectable } from '@angular/core';
import { ChecksService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';
import { Observable } from 'rxjs';
import { SopDetail } from './Models/SopDetail';
import { UserDataService } from 'src/app/services/userData.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageEvaluationService {

  constructor(
    private service: PHBHPApiService,
    public checksService: ChecksService,
    private userDataService: UserDataService
  ) { }

  getProcessComplianceDetails(userId, roleId, institutionId = 0, isSavedFromEvaluation = true) {
    return this.service.getApi(`SOPEvaluation/GetProcessComplianceDetailsMulti/${userId}/${roleId}/${institutionId}`, true);
  }
  getProcessComplianceFilterDetails(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`SOPEvaluation/GetProcessComplianceFilterDetailsMulti/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getSOPDashboardList(userId, roleId, institutionId = 0, countryId = 0) {
    return this.service.getApi(`SOPDashboard/GeSOPDashboardList/${userId}/${roleId}/${institutionId}/${countryId}`, true);
  }
  getProductPackageDetails() {
    return this.service.getApi(`Institutions/GetProductPackageDetails`, true);
  }
  getProductPackageDetailsByCountryId(countryId) {
    return this.service.getApi(`Institutions/GetProductPackageDetailsByCountryId/${countryId}`, true);
  }
  getTopSOPRoutines(userId, roleId, institutionId, countryId = 0) {
    return this.service.getApi(`SOPDashboard/GetTopSOPRoutines/${userId}/${roleId}/${institutionId}/${countryId}`, true);
  }
  getInstitutionsByIds(institutionIds, roleId) {
    if (roleId != 3) {
      return this.service.getApi('institutions/GetInstitutionsByIds/' + institutionIds, true);
    } else {
      return this.service.getApi('institutions/GetInstitutionByGroupId/' + institutionIds, true);
    }
  }
  getUsersInstitutions(data) {
    return this.service.getApi(`ManageInstitution/GetUsersInstitutions/${data.userId}/${data.roleName.roleId}`, true);
  }
  getCountry() {
    return this.service.getApi('UserProfile/GetCountriesList', true);
  }
  getCountryList() {
    return this.service.getApi('countries', true);
  }
  // getCommentsOverview(userId,isSavedFromEvaluation,isCallFor,complianceType,data) {
  //   return this.service.getApi(`SOPEvaluation/GetCommentsOverview/${userId}/${isSavedFromEvaluation}/${isCallFor}/${complianceType}`,data, true);
  // }
  // getObservationsMultiFiltersByComments(userId, complianceType, isCallFor, isSavedFromEvaluation, data) {
  //   return this.service.postApi(`SOPEvaluation/GetCommentsOverviewMultiFilters/${userId}/${complianceType}/${isCallFor}/${isSavedFromEvaluation}`, data, true);
  // }
  getObservationsMultiFiltersByComments(userId, complianceType, isCallFor, isSavedFromEvaluation, data) {
    return this.service.postApi(`SOPEvaluation/GetCommentsOverviewMultiSelect/${userId}/${complianceType}/${isCallFor}/${isSavedFromEvaluation}`, data, true);
  }
  getSOPDetails(userId) {
    return this.service.getApi(`SOPManage/GetSOPList/${userId}`, true);
  }
  getPredefinedComments() {
    return this.service.getApi('observations/GetPredefinedComments', true);
  }
  getPredefinedCommentsListForObservation(countryID, institutionIDs) {
    return this.service.getApi(`observations/GetPredefinedCommentsListForObservation/${countryID}/${institutionIDs}`, true);
  }
  deleteObservation(id, userId) {
    return this.service.deleteApi(`observations/DeleteObservation/${id}/${userId}`, true);
  }
  deleteObservations(ids, userId) {
    return this.service.postApi(`observations/DeleteObservations/${userId}`, ids, true);
  }
  getWardsByInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/' + id, true);
  }
  getAllWardsByInstitutionsIds(ids) {
    return this.service.getApi('ManageInstitution/GetAllInstituionWardsById/' + ids, true);
  }
  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  getDepartmentById(id) {
    return this.service.getApi('Departments/GetDepartmentById/' + id, true);
  }

  getInstitutionByCountryId(countryId) {
    return this.service.getApi('Institutions/GetInstitutionByCountryId/' + countryId, true);
  }
  getIndividualDataOverview(userID, roleID, countryId, lang) {
    return this.service.getApi(`SOPEvaluation/GetIndividualDataOverview/${userID}/${roleID}/${countryId}/${lang}`, true);
  }
  getObservationsFilterByIndividualOverview(userId, isSavedFromEvaluation, countryId, lang, complianceType, data) {
    return this.service.postApi(`SOPEvaluation/GetIndividualDataOverviewByFilter/${userId}/${isSavedFromEvaluation}/${countryId}/${lang}/${complianceType}`, data, true);
  }
  getSOPDashBoardFilterList(userID, data) {
    return this.service.postApi(`SOPDashboard/GetSOPDashBoardFilterList/${userID}`, data, true);
  }
  getObserveDashBoardFilterList(userID, data) {
    return this.service.postApi(`SOPDashboard/GetObserveDashBoardFilterList/${userID}`, data, true);
  }
  getCompletePackageList(userID, data) {
    return this.service.postApi(`SOPDashboard/GetCompletePackageList/${userID}`, data, true);
  }
  GetTopSOPRoutinesFilter(userID, data) {
    return this.service.postApi(`SOPDashboard/GetTopSOPRoutinesFilter/${userID}`, data, true);
  }
  // getSubStepAndFrequencyComplianceFilterDetails(userID, type, isSavedFromEvaluation, complianceType, data, isSubStepCompliance = true) {
  //   return this.service.postApi(`SOPEvaluation/GetSubStepAndFrequencyComplianceFilter/${userID}/${type}/${isSavedFromEvaluation}/${complianceType}/${isSubStepCompliance}`, data, true);
  // }
  getSubStepAndFrequencyComplianceFilterDetails(userID, type, isSavedFromEvaluation, complianceType, data, isSubStepCompliance = true) {
    return this.service.postApi(`SOPEvaluation/GetSubStepAndFrequencyComplianceFilterMulti/${userID}/${type}/${isSavedFromEvaluation}/${complianceType}/${isSubStepCompliance}`, data, true);
  }
  GetProductPackageDetails(data) {
    return this.service.postApi(`Institutions/GetProductPackageDetails`, data, true);
  }
  GetProductPackageDetailsByCountryId(data) {
    return this.service.postApi(`Institutions/GetProductPackageDetailsByCountryId`, data, true);
  }
  getSummarisedReport(userId, userRoleId) {
    return this.service.getApi(`SOPEvaluation/GetSummarisedReport/${userId}/${userRoleId}`, true);
  }
  getSubStepAndFrequencyComplianceDetails(userId, userRoleId, isSavedFromEvaluation, isFrequencyDistribution, isSubStepCompliance = true) {
    return this.service.postApi(`SOPEvaluation/GetSubStepAndFrequencyComplianceDetails/${userId}/${userRoleId}/${isSavedFromEvaluation}/${isFrequencyDistribution}/${isSubStepCompliance}`, {}, true);
  }
  getconsumptionDetails(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ConsumptionEvaluation/GetConsumptionEvaluation/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getConsumptionDetailsMulti(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ConsumptionEvaluation/GetConsumptionEvaluationMulti/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getConsumptionPatientDetailsMulti(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ConsumptionEvaluation/GetConsumptionPatientEvaluationMulti/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getConsumptionPatientDetails(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ConsumptionEvaluation/GetConsumptionPatientEvaluation/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getConsumptionConfigsDetail(data) {
    return this.service.postApi(`ObserveObservation/GetConsumptionConfigsById/`, data, true);
  }
  getconsumptionFilterDetails(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ConsumptionEvaluation/SaveConsumptionEvaluationAndSummarisedDetail/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getFiveMomentsDetails(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetFiveMoments/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  getFiveMomentsDetailsMulti(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetFiveMomentsMulti/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  SaveSummarisedDetail(userId, isSavedFromEvaluation, complianceType, data) {
    return this.service.postApi(`ObserveEvaluation/SaveObserveEvaluationAndSummarisedDetail/${userId}/${isSavedFromEvaluation}/${complianceType}`, data, true);
  }
  getOverallComplianceDetails(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetOverAllCompliance/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  getOverallComplianceDetailsMulti(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetOverAllComplianceMulti/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  getAsepticDetails(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetStatisticsOfBeforeAsepticProcedure/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  getAsepticDetailsMulti(userId, isSavedFromEvaluation, isCallFor, data) {
    return this.service.postApi(`ObserveEvaluation/GetStatisticsOfBeforeAsepticProcedureMulti/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }
  getQuotaDetails(userId, data, isCallFor, countryId, lang, complianceType = false) {

    return this.service.postApi(`ObserveEvaluation/GetQuota/${userId}/${isCallFor}/${countryId}/${lang}`, data, true);
  }
  getIndividualOverView(userId, data, isCallFor, countryId, lang, complianceType = false) {

    return this.service.postApi(`ObserveEvaluation/GetIndividualOverView/${userId}/${isCallFor}/${countryId}/${lang}`, data, true);
  }
  getQuotasDetail(userId, institutionId, departmentId) {
    return this.service.getApi(`SOPDashboard/GetQuotasDetail/${userId}/${institutionId}/${departmentId}`, true);
  }
  getDepartmentsByInstitutionId(institutionID: number) {
    return this.service.getApi('SOPEvaluation/GetWardsAndDepartments/' + institutionID, true);
  }
  deleteObserveObservation(id, userId) {
    return this.service.deleteApi(`observation/DeleteObservation/${id}/${userId}`, true);
  }
  deleteObserveObservations(observationIds, userId) {
    return this.service.postApi(`observation/DeleteObservations/${userId}`, observationIds, true);
  }
  getConfigDetails(id) {
    return this.service.getApi('ObserveObservation/GetGeneralConfigurationByInstitutionId/' + id, true);
  }
  getConfigDetailsByInstitutionIds(ids) {
    return this.service.getApi('ConfigureGeneral/GetGeneralConfigurationByInstitutionIds/' + ids, true);
  }
  getConsumptionsConfigDetailsByIds(ids) {
    return this.service.getApi('ObserveObservation/GetConsumptionsConfigByInstitutionIds/' + ids, true);
  }
  getPredefinedCommentsTranslations() {
    return this.service.getApi(`Translation/GetPredefinedComments`, false);
  }
  getInstitutionDetails(id) {
    return this.service.getApi(`ManageInstitution/GetInstituionDetails/` + id, true);
  }
  getPredefinedCommentsForObservation(countryId, institutionGroupIds, institutionId) {
    return this.service.getApi(`Observations/GetPredefinedCommentsForObservation/${countryId}/${institutionGroupIds}/${institutionId}`, true);
  }
  getInstitutionGroupIdById(institutionId) {
    return this.service.getApi(`Institutions/GetInstitutionGroupIdById/` + institutionId, true);
  }
  getBenchmarkActiveForGraph(institutions) {
    return this.service.getApi(`Institutions/CheckBenchmarkActiveForInstitution/` + institutions, true);
  }

  getFiltersData(data) {
    return this.service.postApi(`SOPEvaluation/GetFiltersData`, data, true);
  }

  getSOPEvaluationSeries(userId, complianceType) {
    return this.service.getApi(`Users/GetSOPEvaluationSerieFilter/${userId}/${complianceType}`, true);
  }

  updateSOPEvaluationSeries(data) {
    return this.service.postApi('Users/UpdateSOPEvaluationSerieFilter', data, true);
  }

  getUserHasSOPEvaluationFilter(userId, complianceType) {
    return this.service.getApi(`Users/GetUserHasSOPEvaluationFilter/${userId}/${complianceType}`, true);
  }

  getUserHasObserveEvaluationFilter(userId, complianceType) {
    return this.service.getApi(`ObserveEvaluation/GetUserHasObserveEvaluationFilter/${userId}/${complianceType}`, true);
  }

  updateFiveMomentsShown(userId, isSavedFromEvaluation, data) {
    return this.service.postApi(`ObserveEvaluation/UpdateFiveMomentsShownInObserveEvaluationFilter/${userId}/${isSavedFromEvaluation}`, data, true);
  }

  updateAsepticProceduresShown(userId, isSavedFromEvaluation, data) {
    return this.service.postApi(`ObserveEvaluation/UpdateAsepticProceduresShownInObserveEvaluationFilter/${userId}/${isSavedFromEvaluation}`, data, true);
  }

  getObserveEvaluationSeries(userId, complianceType) {
    return this.service.getApi(`ObserveEvaluation/GetObserveEvaluationSerieFilter/${userId}/${complianceType}`, true);
  }

  updateObserveEvaluationSeries(data) {
    return this.service.postApi('ObserveEvaluation/UpdateObserveEvaluationSerieFilter', data, true);
  }

  getCommentsOverview(userId, complianceType, isCallFor, isSavedFromEvaluation, data) {
    return this.service.postApi(`ObserveEvaluation/GetCommentsOverview/${userId}/${complianceType}/${isCallFor}/${isSavedFromEvaluation}`, data, true);
  }

  getCommentsOverviewMulti(userId, complianceType, isCallFor, isSavedFromEvaluation, data) {
    return this.service.postApi(`ObserveEvaluation/GetCommentsOverviewMulti/${userId}/${complianceType}/${isCallFor}/${isSavedFromEvaluation}`, data, true);
  }

  getPredefinedCommentsListForIA(countryID, institutionIDs) {
    return this.service.getApi(`observations/getPredefinedCommentsListForIA/${countryID}/${institutionIDs}`, true);
  }

  getDepartmentTypeList() {
    return this.service.getApi('Departments/GetDepartmentTypes', true);
  }

  getInstitutionNames(sop: SopDetail, roleId): string {
    if (!sop) {
      return '';
    }
    let filteredInstitutions = sop.sopInstitutions;
    if (roleId > 3) {
      const allowedInstitutionIds = this.userDataService.institutionsList.map(inst => inst.id);
      filteredInstitutions = filteredInstitutions?.filter(inst => allowedInstitutionIds.includes(inst.institutionID)) || [];
    }
    return filteredInstitutions?.map(institution => institution.institutionName).join(', ') || '';
  }

  // +++++ Hygiene Check Evaluation +++++
  getQuestionnairesByUserAndCountry(userId: number, countryId: string): Observable<any> {
    return this.service.getApi(`HygieneCheckEvaluation/GetQuestionnairesByUserAndCountry/${userId}/${countryId}`, true);
  }

  getCommentsByUserAndCountry(userId: number, countryId: string): Observable<any> {
    return this.service.getApi(`HygieneCheckEvaluation/GetCommentsByUserAndCountry/${userId}/${countryId}`, true);
  }

  getCheckQuickCommentsAnalysis(userId: number, isSavedFromEvaluation: boolean, isCallFor: string, data: any): Observable<any> {
    return this.service.postApi(`HygieneCheckEvaluation/GetQuickCommentsAnalysis/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }

  getCheckOverallCompliance(userId: number, isSavedFromEvaluation: boolean, isCallFor: string, data: any): Observable<any> {
    return this.service.postApi(`HygieneCheckEvaluation/GetOverallComplianceScore/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }

  saveCheckSummarisedDetails(userId: number, isSavedFromEvaluation: boolean, isCallFor: string, data: any): Observable<any> {
    return this.service.postApi(`HygieneCheckEvaluation/SaveCheckEvaluationAndSummarisedDetail/${userId}/${isSavedFromEvaluation}/${isCallFor}`, data, true);
  }

  getHygieneCheckEvaluationSeries(userId, complianceType) {
    return this.service.getApi(`HygieneCheckEvaluation/GetEvaluationSerieFilter/${userId}/${complianceType}`, true);
  }

  updateHygieneCheckEvaluationSeries(data) {
    return this.service.postApi('HygieneCheckEvaluation/UpdateEvaluationSerieFilter', data, true);
  }

  getUserHasCheckEvaluationFilter(userId: number, reportKey: string): Observable<any> {
    return this.service.getApi(`HygieneCheckEvaluation/GetUserHasCheckEvaluationFilter/${userId}/${reportKey}`, true);
  }

  getCheckIndividualAuditData(userId: number, isSavedFromEvaluation: boolean, data: any): Observable<any> {
    return this.service.postApi(`HygieneCheckEvaluation/GetIndividualAuditData/${userId}/${isSavedFromEvaluation}`, data, true);
  }
  // ----- Hygiene Check Evaluation -----
}
